<i18n>
{
  "en": {
    "menuLoadingError": "Error loading menu data",
    "saveMenuSuccess": "Menu saved",
    "saveMenuError": "Error saving menu",
    "saveDynamicAspectsSuccess": "Dynamic aspects saved",
    "saveDynamicAspectsError": "Error saving dynamic aspects",
    "clause": "Clause",
    "clauses": "Clauses",
    "section": "Section",
    "sections": "Sections",
    "subsection": "Subsection",
    "subsections": "Subsections",
    "edit": "Edit",
    "delete": "Delete",
    "deleteItemTitle": "¿Do you want to delete \"{0}\" ?",
    "deleteProductTitle": "¿Do you want to delete this product?",
    "deleteItemDescription": "This change can not be undone",
    "product": "Product",
    "products": "Products",
    "separator": "Subsection",
    "noDataInMenu": "Add clauses to menu",
    "noDataInClause": "Add sections to clause",
    "noDataInSection": "Add subsections or products to section",
    "noDataInSubsection": "Add products to subsection",
    "createError": "Error creating, try it later",
    "createSuccessInformation": "Creating done successfully. To reflect the changes in the menu you must republish",
    "editError": "Error editing, try it later",
    "editSuccessInformation": "Editing done successfully. To reflect the changes in the menu you must republish",
    "deleteError": "Error deleting, the menu might have an error, please contact support",
    "deleteSuccessInformation": "Delete completed successfully. To reflect the changes in the menu you must republish",
    "moveError": "Error ordering, try it later",
    "and": "and",
    "add": "Add new",
    "editMenu": "Edit menu",
    "editMenuSuccess": "Menu \"{0}\" was successfully edited!",
    "editMenuError": "Error editing menu \"{0}\". Please, try it later.",
    "publishMenuError": "Error publishing menu. Please, try it later.",
    "publishLoading": "Publishing menu",
    "restrictionError": "Menu \"{0}\" can't be published since it's in the middle of a service. Please, try again at {1}.",
    "appearanceMenuError": "Error editing menu's theme. Please, try it later.",
    "appearanceMenuSuccess": "Menu's theme was successfully edited!",
    "appearance": "Set styles of menu",
    "publish": "Publish menu",
    "preview": "See menu",
    "publicationInProgress": "There is a publication in progress for this menu, try it again later",
    "settingsMenuError": "Error editing menu's theme settings. Please, try again later.",
    "settingsMenuSuccess": "Menu's theme settings was successfully edited!",
    "settings": "Menu settings",
    "confirmHideSectionTitle": "¿Do you want to hide this section?",
    "confirmHideSectionDescription": "The section won't be visible in the menu.",
    "confirm": "Confirm",
    "confirmShowSectionTitle": "¿Do you want show this section?",
    "confirmShowSectionDescription": "The section will be visible in the menu.",
    "gridItemInformation": "You have to add the new section in the grid generator, otherwise the menu will be displayed incorrectly"
  },
  "es": {
    "menuLoadingError": "Error cargando datos del menú",
    "saveMenuSuccess": "Menú guardado",
    "saveMenuError": "Error guardando menu",
    "saveDynamicAspectsSuccess": "Aspectos dinámicos guardados",
    "saveDynamicAspectsError": "Error guardando aspectos dinámicos",
    "clause": "Apartado",
    "clauses": "Apartados",
    "section": "Sección",
    "sections": "Secciones",
    "subsection": "Subsección",
    "subsections": "Subsecciones",
    "edit": "Editar",
    "delete": "Eliminar",
    "deleteItemTitle": "¿Desea borrar \"{0}\" ?",
    "deleteProductTitle": "¿Desea borrar este producto?",
    "deleteItemDescription": "Este cambio es irreversible",
    "product": "Producto",
    "products": "Productos",
    "separator": "Subsección",
    "noDataInMenu": "Añade apartados al menú",
    "noDataInClause": "Añade secciones al apartado",
    "noDataInSection": "Añade subsecciones o productos a la sección",
    "noDataInSubsection": "Añade productos a la subsección",
    "createError": "Error creando, inténtelo de nuevo más tarde",
    "createSuccessInformation": "Creación realizada satisfactoriamente. Para reflejar los cambios en el menú debe republicar",
    "editError": "Error editando, inténtelo de nuevo más tarde",
    "editSuccessInformation": "Edición realizada satisfactoriamente. Para reflejar los cambios en el menú debe republicar",
    "deleteError": "Error eliminando, el menú puede tener un error, por favor, contacte con soporte",
    "deleteSuccessInformation": "Eliminación realizada satisfactoriamente. Para reflejar los cambios en el menú debe republicar",
    "moveError": "Error ordenando, inténtelo de nuevo más tarde",
    "and": "y",
    "add": "Añadir nuevo",
    "editMenu": "Editar menú",
    "editMenuSuccess": "El menú \"{0}\" se editó correctamente",
    "publishLoading": "Publicando el menú",
    "publishMenuError": "Error al publicar el menú. Inténtelo de nuevo más tarde.",
    "restrictionError": "No se puede publicar el menú \"{0}\" porque está en medio de un servicio. Inténtelo de nuevo a la{2} {1}.",
    "appearanceMenuError": "Error al editar el tema del menú. Inténtelo de nuevo más tarde.",
    "appearance": "Personalizar apariencia del menú",
    "appearanceMenuSuccess": "El tema del menú se editó correctamente",
    "publish": "Publicar menú",
    "preview": "Ver carta",
    "publicationInProgress": "Ya hay una publicación en curso para este menú, inténtelo más tarde.",
    "settings": "Ajustes de menú",
    "settingsMenuError": "Error al editar los ajustes del tema del menú. Inténtelo de nuevo más tarde.",
    "settingsMenuSuccess": "Los ajustes del tema del menú se editó correctamente",
    "confirmHideSectionTitle": "¿Desea ocultar la sección?",
    "confirmHideSectionDescription": "La sección no sera visible en el menu.",
    "confirm": "Confirmar",
    "confirmShowSectionTitle": "¿Desea mostrar la sección?",
    "confirmShowSectionDescription": "La sección sera visible en el menu",
    "gridItemInformation": "Tiene que añadir el nuevo apartado en el generador de cuadrilla, si no el menu se mostrara erroneo"
  }
}
</i18n>

<template>
  <div class="section-editor pb-8">
    <v-card>
      <v-card-actions>
        <v-menu offset-y>
          <template v-slot:activator="{ on }" v-if="buttonConfigList.length !== 0">
            <v-btn icon v-on="on">
              <v-icon dense>fa-ellipsis-v</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="button in buttonConfigList" :key="button.title"
                         @click="onOpenModal(button.modal)">
              <v-list-item-content>
                <v-list-item-title>{{ button.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-card-text v-bind:class="titleClasses">
          {{ title }}
        </v-card-text>
        <v-spacer></v-spacer>
        <v-tooltip top v-if="allowProductCreationModal">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon class="mr-2" v-on="on" v-bind="attrs" @click="onOpenModal('search')">
              <v-icon color="grey" large>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ this.$t('add') }}</span>
        </v-tooltip>
        <v-menu v-else-if="allowBothCreationModals">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon color="grey" large>mdi-plus</v-icon>
            </v-btn>
          </template>
          <div class="itemSelector">
            <v-list>
              <v-list-item :key="'createProduct'" @click="onOpenModal('search')">
                <v-list-item-content>
                  <v-list-item-title>{{ $t('product') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item :key="'createSection'" @click="onOpenModal('create-section')">
                <v-list-item-content>
                  <v-list-item-title>{{ sectionCreationButtonMessage }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-menu>
        <v-tooltip top v-else-if="allowSectionCreationModals">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon class="mr-2" v-on="on" v-bind="attrs"
                   @click="onOpenModal('create-section')">
              <v-icon color="grey" large>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ this.$t('add') }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
    <product-search-modal :visible="productSearchModalVisible" @confirm="onLoadProduct"
                          @cancel="onCloseModals"/>
    <product-item-create-edit-modal :visible="createProductModalVisible" @confirm="onCreateProduct"
                                    @cancel="onCloseModals" @edit-master="onManualEdit"
                                    @added-managed="onAddedManaged"
                                    :newOrder="newOrder" :product="productToCreate"/>
    <product-item-create-edit-modal :visible="editProductModalVisible" @edit-master="onManualEdit"
                                    @confirm="onEditProduct" @cancel="onCloseModals"
                                    :product="productToEdit" :isManaged="isMenuManaged"
                                    type="edit"/>
    <master-product-modal :visible="masterProductModalVisible" :product-prop="masterProductToEdit"
                          @close="onEditMasterProduct"/>
    <section-create-edit-modal :visible="createSectionModalVisible" @confirm="onCreateSection"
                               @cancel="onCloseModals"
                               :section="sectionToCreate" :newOrder="newOrder"
                               :is-section="isSection"
                               :is-clause="isClause"
                               :templateGuid="currentTemplateGuid"
                               :isManaged="isMenuManaged"/>
    <section-create-edit-modal :visible="editSectionModalVisible" @confirm="onEditSection"
                               @cancel="onCloseModals"
                               :section="sectionToEdit" type="edit" :is-section="isSection"
                               :is-clause="isClause"
                               :templateGuid="currentTemplateGuid"
                               :isMenuManaged="isMenuManaged"/>
    <menu-create-edit-modal :visible="editMenuModalVisible" @confirm="onEditMenu"
                            @cancel="onCloseModals"
                            :menu="menuToEdit" type="edit"/>
    <menu-appearance-modal :visible="appearanceMenuModalVisible" @confirm="onAppearanceMenu"
                           @cancel="onCloseModals" :theme-guid="themeGuidToEdit"
                           :template-guid="currentTemplateGuid"/>
    <menu-settings-modal :visible="settingsMenuModalVisible"
                         @confirm="onSettingsMenu"
                         @cancel="onCloseModals"
                         :menu-configuration-guid="menuConfigurationGuidToEdit"
                         :template-guid="currentTemplateGuid"
                         :menu-guid="menuGuidToEdit"
                         :initial-recommendations="menuInitialRecommendationsByDefault"/>
    <dynameat-confirmation-modal :visible="publishModalLoadingVisible"
                                 :title="$t('publishLoading')"
                                 :is-loading="isLoading"/>
    <dynameat-confirmation-modal :visible="deleteModalVisible"
                                 :title="deletionText"
                                 :description="$t('deleteItemDescription')"
                                 :confirm-text="$t('delete')"
                                 @confirm="onDelete"
                                 @cancel="onCloseModals"/>
    <dynameat-confirmation-modal :visible="hideSectionModalVisible"
                                 :title="$t('confirmHideSectionTitle')"
                                 :description="$t('confirmHideSectionDescription')"
                                 :confirm-text="$t('confirm')"
                                 @confirm="onHideSection(sectionToEdit)"
                                 @cancel="onCloseModals"/>
    <dynameat-confirmation-modal :visible="showSectionModalVisible"
                                 :title="$t('confirmShowSectionTitle')"
                                 :description="$t('confirmShowSectionDescription')"
                                 :confirm-text="$t('confirm')"
                                 @confirm="onShowSection(sectionToEdit)"
                                 @cancel="onCloseModals"/>
    <v-list>
      <div v-if="!isLoading">
        <draggable v-model="currentItemList" :disabled="isMenuManaged" v-bind="dragOptions">
          <transition-group type="transition">
            <section-product-row v-for="(item, index) in currentItemList" :key="item.order"
                                 :item="item"
                                 :index="index" :size="currentItemList.length"
                                 :isManaged="isMenuManaged"
                                 @edit-product="onOpenModal('edit-product', item)"
                                 @edit-section="onOpenModal('edit-section', item)"
                                 @hide-section="onOpenModal('hide-section', item)"
                                 @show-section="onOpenModal('show-section', item)"
                                 @delete="onOpenModal('delete', item)"
                                 @click-content="onClickItem(item)"
                                 @move="onMove"/>
          </transition-group>
        </draggable>
      </div>
    </v-list>
    <div v-if="currentItemListIsEmpty && !isLoading" class="empty-data">
      <p class="grey--text">{{ this.$t(this.noDataString) }}</p>
    </div>
    <dynameat-skeleton v-if="!isMenuManaged && isLoading" skeleton-type="menuList"
                       :container="false"/>
    <dynameat-skeleton v-if="isMenuManaged && isLoading" skeleton-type="menuEditorManaged"
                       :container="false"/>
  </div>
</template>

<script>
import DynameatConfirmationModal from '@dynameat/components/DynameatConfirmationModal';
import {
  createErrorNotification,
  createSuccessNotification,
  createWarningNotification
} from '@ulibs/unnotificationsqueue';
import DynameatSkeleton from '@dynameat/components/DynameatSkeleton';
import Component from 'vue-class-component';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import Vue from 'vue';
import draggable from 'vuedraggable';
import MasterProductModal from '@masters/views/product/components/MasterProductModal.vue';
import { Menu } from '@dynameat/views/pointOfSale/models';
import { Watch } from 'vue-property-decorator';
import { menuSectionTypes } from '../../../models';
import MenuCreateEditModal from '../../../components/MenuCreateEditModal.vue';
import MenuAppearanceModal from '../../../components/MenuAppearanceModal.vue';
import MenuSettingsModal from '../../../components/MenuSettingsModal.vue';
import { getDeployedPublication } from '../../../processes';
import SectionProductRow from './SectionProductRow.vue';
import SectionCreateEditModal from './SectionCreateEditModal.vue';
import ProductItemCreateEditModal from './ProductItemCreateEditModal.vue';
import ProductSearchModal from './ProductSearchModal.vue';
import { ProductItem, Section } from '../models';

Component.registerHooks(['beforeRouteLeave']);
@Component
@Components({
  DynameatSkeleton,
  DynameatConfirmationModal,
  ProductSearchModal,
  SectionCreateEditModal,
  ProductItemCreateEditModal,
  SectionProductRow,
  MenuCreateEditModal,
  MenuAppearanceModal,
  MenuSettingsModal,
  MasterProductModal,
  draggable
})
@MapGetters(['currentSection', 'currentSectionList', 'isSection', 'isSubsection', 'currentMenu',
  'isMenuManaged', 'currentSectionProducts', 'isClause', 'currentSectionCodeName', 'isLoading',
  'currentTemplate', 'editableProductList', 'templateList', 'menuInitialRecommendationList',
  'getSectionByGuid'])
@MapActions([
  'addNotification', 'menuRequest', 'createSection', 'editSection', 'deleteSection', 'editMenu',
  'createProduct', 'editProduct', 'deleteProduct', 'moveItem', 'editMenuRequest', 'setLoading',
  'publishMenuRequest', 'editThemeRequest', 'updateMenuPublication', 'editTheme', 'reorderItems',
  'updateMasterProductRequest', 'createRecommendation', 'editRecommendation',
  'recommendationListRequest', 'deleteRecommendation', 'editMenuConfigurationRequest'])
export default class SectionProductList extends Vue {
  sectionToCreate = null;

  sectionToEdit = null;

  productToCreate = null;

  productToEdit = null;

  masterProductToEdit = null;

  itemToDelete = null;

  menuToEdit = null;

  menuGuidToEdit = null

  themeGuidToEdit = null;

  publishModalLoadingVisible = false;

  editMenuModalVisible = false;

  appearanceMenuModalVisible = false;

  settingsMenuModalVisible = false;

  createProductModalVisible = false;

  editProductModalVisible = false;

  masterProductModalVisible = false;

  createSectionModalVisible = false;

  editSectionModalVisible = false;

  deleteModalVisible = false;

  productSearchModalVisible = false;

  hideSectionModalVisible = false;

  showSectionModalVisible = false;

  manualEditing = false;

  movingItem = false;

  waiter = null;

  menuInitialRecommendationsByDefault = []

  menuConfigurationGuidToEdit = null

  get itemToDeleteTitle() {
    return this.itemToDelete ? this.itemToDelete.title : null;
  }

  get currentItemList() {
    const sectionsProducts = [...this.currentSectionProducts, ...this.currentSectionList];
    return sectionsProducts.sort((a, b) => (a.order > b.order ? 1 : -1));
  }

  set currentItemList(newList) {
    // On Drag and Drop
    if (!this.movingItem) {
      this.movingItem = true;
      this.reorderItems({ oldItemsList: this.currentItemList, newItemsList: newList });
      this.movingItem = false;
    }
  }

  get newOrder() {
    return this.currentItemList.length;
  }

  get currentItemListIsEmpty() {
    return this.currentItemList.length === 0;
  }

  get currentPermissions() {
    return this.currentTemplate ? this.currentTemplate.getAllowedChildren(this.currentSectionCodeName) : [];
  }

  get canCreateClauses() {
    return !this.isMenuManaged && this.currentSectionCodeName === menuSectionTypes.MENU;
  }

  get canCreateSections() {
    return !!this.currentPermissions.find((el) => el === menuSectionTypes.SECTION);
  }

  get canCreateSubsections() {
    return !!this.currentPermissions.find((el) => el === menuSectionTypes.SUBSECTION);
  }

  get canCreateProducts() {
    return !!this.currentPermissions.find((el) => el === menuSectionTypes.PRODUCT);
  }

  get canOnlyCreateSections() {
    return this.canCreateSections && !this.canCreateProducts && !this.canCreateSubsections
      && !this.canCreateClauses;
  }

  get canCreateProductAndSections() {
    return this.canCreateProducts && this.canCreateSections;
  }

  get canCreateProductAndSubsections() {
    return this.canCreateProducts && this.canCreateSubsections;
  }

  get allowSectionCreationModals() {
    return this.canCreateSubsections || this.canCreateSections || this.canCreateClauses;
  }

  get allowBothCreationModals() {
    return this.canCreateProductAndSections || this.canCreateProductAndSubsections;
  }

  get allowProductCreationModal() {
    // (!this.canCreateSubsections || this.isMenuManaged) => to allow create products in a managed
    // section but not subsections
    return this.canCreateProducts && !this.canCreateSections
      && !this.canCreateSubsections && !this.canCreateClauses;
  }

  get sectionCreationButtonMessage() {
    return this.canCreateSubsections ? this.$t('subsection') : this.$t('section');
  }

  get currentTemplateGuid() {
    return this.currentTemplate ? this.currentTemplate.guid : null;
  }

  get dragOptions() {
    // Fallback class applies only in "mobile mode" to avoid the bottom of the list bug when sorting
    if (this.$vuetify.breakpoint.smAndDown) {
      return {
        fallbackOnBody: true,
        fallbackClass: 'dragged',
        delay: 100,
      };
    }
    return {};
  }

  get title() {
    let title = this.$t('clauses');
    title = this.canOnlyCreateSections ? this.$t('sections') : title;
    title = this.canCreateProductAndSections ? `${this.$t('sections')} ${this.$t('and')} ${this.$t('products')}` : title;
    title = this.canCreateProductAndSubsections ? `${this.$t('subsections')} ${this.$t('and')} ${this.$t('products')}` : title;
    title = this.allowProductCreationModal ? this.$t('products') : title;
    return title;
  }

  get titleClasses() {
    return this.isMenuManaged ? 'text-center pl-0 text-h6 py-1' : 'text-center pl-10 text-h6 py-1';
  }

  get noDataString() {
    let type = this.isClause ? 'Clause' : 'Menu';
    type = this.isSection ? 'Section' : type;
    type = this.isSubsection ? 'Subsection' : type;
    return `noDataIn${type}`;
  }

  get deletionText() {
    return this.itemToDeleteTitle ? this.$t('deleteItemTitle', [this.itemToDeleteTitle]) : this.$t('deleteProductTitle');
  }

  get template() {
    return (this.currentMenu) ? this.templateList.find((temp) => temp.guid === this.currentMenu.template) : null;
  }

  get showGridGenerator() {
    return this.template ? !this.template.isOperationDisallowed('MENU_ACTIONS', 'GRID_GENERATOR') : false;
  }

  get buttonConfigList() {
    const buttons = [
      {
        title: `${this.$t('publish')}`,
        modal: 'publish-menu'
      },
      {
        title: `${this.$t('appearance')}`,
        modal: 'appearance-menu'
      },
      {
        title: `${this.$t('editMenu')}`,
        modal: 'edit-menu'
      },
    ];
    if (this.template?.hasSettings()) {
      buttons.push({
        title: `${this.$t('settings')}`,
        icon: 'mdi-wrench',
        emitName: 'settings',
        modal: 'settings-menu'
      });
    }
    if (this.currentMenu?.publication) {
      buttons.unshift(
        {
          title: `${this.$t('preview')}`,
          modal: 'preview-publication'
        },
      );
    }
    return buttons;
  }

  beforeRouteLeave(to, from, next) {
    if (this.waiter) this.waiter.forceClear();
    if (this.isLoading) {
      this.setLoading(-1);
    }
    next();
  }

  async created() {
    this.productToCreate = undefined;
    this.productToEdit = undefined;
    this.itemToDelete = undefined;
    await this.menuRequest(this.$route.params.menuGuid);
    await this.recommendationListRequest();
  }

  onOpenModal(type, item) {
    switch (type) {
      case 'edit-menu':
        const props = this.currentMenu.serialize();
        this.menuToEdit = Menu.toInstance(props); // Copy constructor
        this.editMenuModalVisible = true;
        break;
      case 'appearance-menu':
        this.themeGuidToEdit = this.currentMenu.theme;
        this.appearanceMenuModalVisible = true;
        break;
      case 'settings-menu':
        this.themeGuidToEdit = this.currentMenu.theme;
        this.settingsMenuModalVisible = true;
        this.menuGuidToEdit = this.currentMenu.guid;
        this.menuConfigurationGuidToEdit = this.currentMenu.menu_configuration;
        this.menuInitialRecommendationsByDefault = this.menuInitialRecommendationList.filter(
          (recommendation) => !!this.currentMenu && recommendation.activeByDefault
            && recommendation.menu === this.currentMenu.guid
        );
        break;
      case 'create-product':
        this.productToCreate = new ProductItem(item);
        this.createProductModalVisible = true;
        break;
      case 'create-section':
        this.sectionToCreate = new Section();
        this.sectionToCreate.is_visible = true;
        this.createSectionModalVisible = true;
        break;
      case 'edit-product':
        this.productToEdit = new ProductItem(item);
        this.editProductModalVisible = true;
        break;
      case 'edit-master-product':
        this.masterProductToEdit = item;
        this.masterProductModalVisible = true;
        break;
      case 'edit-section':
        this.sectionToEdit = new Section(item);
        this.editSectionModalVisible = true;
        break;
      case 'delete':
        this.deleteModalVisible = true;
        this.itemToDelete = item;
        break;
      case 'search':
        this.productSearchModalVisible = true;
        break;
      case 'publish-menu':
        this.onPublish(this.currentMenu);
        break;
      case 'preview-publication':
        this.onPreview(this.currentMenu.publication);
        break;
      case 'hide-section':
        this.sectionToEdit = new Section(item);
        this.hideSectionModalVisible = true;
        break;
      case 'show-section':
        this.sectionToEdit = new Section(item);
        this.showSectionModalVisible = true;
        break;
    }
  }

  async onClickItem(item) {
    if (item instanceof ProductItem) {
      this.productToEdit = new ProductItem(item);
      this.editProductModalVisible = true;
    } else {
      await this.$router.push({
        name: 'sectionEditor',
        params: { menuGuid: this.currentMenu.guid, sectionGuid: item.guid }
      });
    }
  }

  onCloseModals() {
    this.createSectionModalVisible = false;
    this.editSectionModalVisible = false;
    this.createProductModalVisible = false;
    this.editProductModalVisible = false;
    this.deleteModalVisible = false;
    this.productSearchModalVisible = false;
    this.editMenuModalVisible = false;
    this.appearanceMenuModalVisible = false;
    this.settingsMenuModalVisible = false;
    this.publishModalLoadingVisible = false;
    this.masterProductModalVisible = false;
    this.hideSectionModalVisible = false;
    this.showSectionModalVisible = false;
  }

  onLoadProduct(product) {
    this.productSearchModalVisible = false;
    if (product.is_new || !product.isConfigured) {
      this.onOpenModal('edit-master-product', product);
    } else {
      const productItem = new ProductItem(product);
      productItem.guid = new Date().getTime().toString();
      productItem.product = product.guid;
      productItem.is_visible = true;
      this.masterProductModalVisible = false;
      this.masterProductToEdit = null;
      this.onOpenModal('create-product', productItem);
    }
  }

  onManualEdit(productGuid) {
    const product = this.editableProductList.find((el) => el.guid === productGuid);
    if (product) {
      this.manualEditing = true;
      this.onOpenModal('edit-master-product', product);
    }
  }

  async onEditMasterProduct(product) {
    this.masterProductModalVisible = false;
    this.masterProductToEdit = null;
    if (this.manualEditing) {
      this.manualEditing = false;
    } else if (product !== undefined) {
      const productItem = new ProductItem(product);
      productItem.guid = new Date().getTime().toString();
      productItem.product = product.guid;
      productItem.is_visible = true;
      this.onOpenModal('create-product', productItem);
    }
  }

  async onCreateProduct(product) {
    try {
      await this.createProduct(product);
      this.addNotification(createSuccessNotification(this.$t('createSuccessInformation')));
    } catch (err) {
      this.addNotification(createErrorNotification(this.$t('createError')));
    } finally {
      this.onCloseModals();
      this.productToCreate = undefined;
    }
  }

  async onEditProduct(product) {
    try {
      await this.editProduct(product);
      this.addNotification(createSuccessNotification(this.$t('editSuccessInformation')));
    } catch (err) {
      this.addNotification(createErrorNotification(this.$t('editError')));
    } finally {
      this.onCloseModals();
      this.productToEdit = undefined;
    }
  }

  async onDelete() {
    try {
      if (this.itemToDelete instanceof Section) await this.deleteSection(this.itemToDelete);
      else await this.handleDeleteProduct(this.itemToDelete);
      this.addNotification(createSuccessNotification(this.$t('deleteSuccessInformation')));
    } catch (err) {
      this.addNotification(createErrorNotification(this.$t('deleteError')));
    } finally {
      this.onCloseModals();
      this.itemToDelete = undefined;
    }
  }

  async handleDeleteProduct(productItem) {
    await this.deleteProduct(productItem);
    if (productItem.is_managed) {
      const section = this.getSectionByGuid(productItem.section);
      const sections = [section, ...section.getParentSections(this.getSectionByGuid)];
      sections.forEach((sectionToEdit) => {
        const hasManagedProducts = sectionToEdit.hasManagedProducts();
        if (hasManagedProducts !== sectionToEdit.has_managed_products) {
          sectionToEdit.has_managed_products = hasManagedProducts;
          this.editSection(section);
        }
      });
    }
  }

  async onMove(item, value) {
    if (!this.movingItem) {
      try {
        this.movingItem = true;
        if (item instanceof ProductItem) await this.onMoveProduct(item, value);
        else await this.onMoveSection(item, value);
      } catch (err) {
        this.addNotification(createErrorNotification(this.$t('moveError')));
      } finally {
        this.movingItem = false;
      }
    }
  }

  async onMoveProduct(product, value) {
    try {
      await this.moveItem({ item: product, value });
    } catch (err) {
      this.addNotification(createErrorNotification(this.$t('moveError')));
    }
  }

  async onCreateSection(section) {
    try {
      await this.createSection(section);
      this.addNotification(createSuccessNotification(this.$t('createSuccessInformation')));
      if (section.type === 1 && this.showGridGenerator) {
        this.addNotification(createSuccessNotification(this.$t('gridItemInformation')));
      }
    } catch (err) {
      this.addNotification(createErrorNotification(this.$t('createError')));
    } finally {
      this.onCloseModals();
      this.sectionToCreate = null;
    }
  }

  async onEditSection(section) {
    try {
      await this.editSection(section);
      this.addNotification(createSuccessNotification(this.$t('editSuccessInformation')));
    } catch (err) {
      this.addNotification(createErrorNotification(this.$t('editError')));
    } finally {
      this.onCloseModals();
      this.sectionToEdit = null;
    }
  }

  async onMoveSection(section, value) {
    console.log('asdas');
    try {
      await this.moveItem({ item: section, value });
    } catch (err) {
      this.addNotification(createErrorNotification(this.$t('moveError')));
    }
  }

  async onEditMenu(menu) {
    try {
      this.editMenu(menu);
      await this.editMenuRequest(menu);
      this.addNotification(createSuccessNotification(this.$t('editMenuSuccess', [menu.title]), null, 2000));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('editMenuError', [menu.title])));
    } finally {
      this.onCloseModals();
      this.menuToEdit = null;
    }
  }

  async onAppearanceMenu(theme) {
    try {
      this.editTheme(theme);
      await this.editThemeRequest(theme);
      this.addNotification(createSuccessNotification(this.$t('appearanceMenuSuccess'), null, 2000));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('appearanceMenuError')));
    } finally {
      this.onCloseModals();
      this.themeGuidToEdit = null;
    }
  }

  async onSettingsMenu({ menuConfiguration, initialRecommendations, deletedInitialRecommendations }) {
    try {
      await this.editMenuConfigurationRequest(menuConfiguration);
      for (const recommendation of initialRecommendations) {
        if (recommendation.guid) {
          await this.editRecommendation(recommendation);
        } else {
          await this.createRecommendation(recommendation);
        }
      }

      for (const deletedRecommendation of deletedInitialRecommendations) {
        await this.deleteRecommendation(deletedRecommendation);
      }
      this.addNotification(createSuccessNotification(this.$t('settingsMenuSuccess'), null, 2000));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('settingsMenuError')));
    } finally {
      this.onCloseModals();
      this.themeGuidToEdit = null;
      this.menuConfigurationGuidToEdit = null;
    }
  }

  async onPublish(menu) {
    try {
      this.setLoading(1);
      this.publishModalLoadingVisible = true;
      const publicationGuid = await this.publishMenuRequest(menu.guid);
      await this.publishing(menu, publicationGuid);
    } catch (err) {
      this.setLoading(-1);
      if (err.response.status === 409) {
        const time = err.response.data.time_to.split(':').slice(0, 2);
        this.addNotification(createErrorNotification(this.$t('restrictionError',
          [menu.title, `${time[0]}:${time[1]}`, time[0] === 1 ? '' : 's'])));
      } else if (err.response.status === 202) {
        this.addNotification(createWarningNotification(this.$t('publicationInProgress'), {}, 7000));
      } else {
        this.addNotification(createErrorNotification(this.$t('publishMenuError', [menu.title])));
      }
    } finally {
      this.onCloseModals();
    }
  }

  async publishing(menu, publicationGuid) {
    this.waiter = getDeployedPublication(publicationGuid);
    const updatedPublication = await this.waiter.initialize();
    this.updateMenuPublication({ menuGuid: menu.guid, updatedPublication });
    this.onPreview(updatedPublication, menu);
    this.publishModalLoadingVisible = false;
    this.setLoading(-1);
  }

  onPreview(publication) {
    const publicationUrl = `${publication.publication_info_by_zone[0].publication_link}&avoidRedirect=true`;
    const { width, height } = this.currentTemplate.getWidthAndHeight();
    window.open(publicationUrl, 'menu', `toolbar=0,menubar=1,resizable=0,width=${width},height=${height}`);
  }

  async onHideSection(section) {
    try {
      section.is_visible = false;
      await this.editSection(section);
    } catch (err) {
      this.addNotification(createErrorNotification(this.$t('editError')));
    } finally {
      this.onCloseModals();
      this.sectionToEdit = null;
    }
  }

  async onShowSection(section) {
    try {
      section.is_visible = true;
      await this.editSection(section);
    } catch (err) {
      this.addNotification(createErrorNotification(this.$t('editError')));
    } finally {
      this.onCloseModals();
      this.sectionToEdit = null;
    }
  }

  async onAddedManaged(sectionGuid) {
    try {
      const section = this.getSectionByGuid(sectionGuid);
      section.is_visible = true;
      section.has_managed_products = true;
      await this.editSection(section);

      const parentSections = section.getParentSections(this.getSectionByGuid);
      parentSections.forEach((parentSection) => {
        parentSection.is_visible = true;
        parentSection.has_managed_products = true;
        this.editSection(parentSection);
      });
    } catch (err) {
      this.addNotification(createErrorNotification(this.$t('editError')));
    } finally {
      this.onCloseModals();
      this.sectionToEdit = null;
    }
  }

  @Watch('$route')
  onRouteChanged(to, from) {
    if (to !== from) {
      this.onCloseModals();
    }
  }
}
</script>

<style scoped>
.empty-data {
  text-align: center;
}

.dragged {
  font-family: Roboto, sans-serif;
}
</style>
